// extracted by mini-css-extract-plugin
module.exports = {"image":"deactivated-modal_image__1-vpQ","container":"deactivated-modal_container__1w3zV","title":"deactivated-modal_title__86DG3"};